export function LoadingTrail({ message = 'Finding the trail…' }: { message?: string }) {
  return (
    <main className="loading-screen" aria-live="polite">
      <div className="loading-compass">✦</div>
      <p>{message}</p>
    </main>
  );
}
